/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const FIBER_PTP_URL = `${API_URL}/fiberpptp`;
